import React from "react";

import Toolbar from "../../../../components/tasklayout/toolbar/Toolbar";
import Viewbar from "../../../../components/tasklayout/toolbar/features/viewbar/Viewbar";
import { getCardInfo } from "../../../../lib/getCardInfo";
import { TaskPageEnums } from "../../../../utils/Enums/TaskPageEnums";
import { useTaskFilter } from "../../../../utils/Context/TaskFilterContext";
import useProjectTaskList from "../../hooks/useProjectTaskList";

const MyProjectsTaskList = () => {
    const { resetFilters } = useTaskFilter();

    const {
        projectId,
        cardData,
        taskList,
        showCompleted,
        hasMore,
        totalCount,
        isInitialLoad,
        isRefreshing,
        isLoadingMore,
        hasActiveFilters,
        hasActiveSearch,
        isError,
        onToggleChange,
        onSearchChange,
        handleRefreshGrid,
        handleLoadMore,
        handleRetry,
        patchTask,
    } = useProjectTaskList({
        getExtraFilter: ({ userId }) => ({
            Field: "AssignedTo",
            Operator: "Is",
            Value: userId?.toString() || "0",
        }),
    });

    return (
        <div className="task-layout">
            {cardData?.length > 0 && (
                <div className="card-section-info">
                    {getCardInfo(cardData)}
                </div>
            )}
            <div>
                <Viewbar
                    projectId={projectId}
                    showCompleted={showCompleted}
                    onToggleChange={onToggleChange}
                    onSearchChange={onSearchChange}
                    taskFilterPageId={TaskPageEnums.MY_PROJECT_TASK}
                />
            </div>
            <div className="task-layout-toolbar">
                <Toolbar
                    projectId={projectId}
                    taskListData={taskList}
                    isTeamPlanning={false}
                    allowEditStatus={true}
                    allowEditAssignee={false}
                    isShowActualTime={true}
                    isDataLoading={isInitialLoad}
                    isRefreshing={isRefreshing}
                    isError={isError}
                    onRetry={handleRetry}
                    onClearFilters={resetFilters}
                    hasActiveFilters={hasActiveFilters}
                    hasActiveSearch={hasActiveSearch}
                    onRefreshGrid={handleRefreshGrid}
                    onLoadMoreTasks={handleLoadMore}
                    isLoadingMore={isLoadingMore}
                    hasMore={hasMore}
                    totalCount={totalCount}
                    onTaskPatch={patchTask}
                />
            </div>
        </div>
    );
};

export default MyProjectsTaskList;
